module.exports = __webpack_public_path__ + "static/media/angela_ling.9e7b2100.png";